export const businessPath = (businessId, organizationId, section = '') => {
  if (!businessId || !organizationId) throw new Error('Business and account IDs are required')
  const base = `/business-account/${organizationId}/business/${businessId}`
  return section ? `${base}/${section}` : base
}
